import React from 'react';
import './Blog.css';

import { extractDateParts } from '../../utils'; // Utility function to extract date parts

import { Link } from 'react-router-dom'; // Importing Link for navigation



const Blog = ({ blog }) => {

  const { id, image, date, heading, content, category } = blog; // Extracting data from blog
  const { day, shortMonth } = extractDateParts(date); // Extracting formatted date parts using utility function

  return (
    <div className='blog-item' key={id}>

      {/* Blog image */}
      <div className='image'>
        <img src={image} alt={heading} />
        <div className='date'>{day} {shortMonth}</div>
      </div>

      <div className='content'>

        <Link className='label' to={`/Blogs/category/${category}`}>{category}</Link> {/* Blog category with navigation link */}

        {/* Blog title with dynamic navigation */}
        <Link
          to={{
            pathname: '/Blogs/' + heading,
          }}
          state={blog}
          className='main-heading'>
          {heading}
        </Link>

        <p>{content}</p> {/* Blog Description */}

      </div>

    </div>
  );
};

export default Blog;